import React from "react";
import { View, Text, Image, StyleSheet } from "../platformComponents";
import { IS_WEB, tranformPx } from "@adgm/libs";

interface ManagerBackgroundProps {
  title: string;
  image: string;
  text: string;
}

export const ManagerBackground: React.FC<ManagerBackgroundProps> = ({ title, image, text }) => (
  <View style={styles.container}>
    <Text style={styles.title}>{title}</Text>
    <View style={styles.card}>
      <Image
        style={styles.img}
        accessibilityLabel="ManagerBackgroundImage"
        source={{ uri: image }}
        resizeMode="cover"
      />
      <Text style={styles.text}>{text}</Text>
    </View>
  </View>
);

const styles = StyleSheet.create({
  container: {
    width: "100%",
    ...(IS_WEB && {
      height: "100%",
      display: "flex",
      flexDirection: "column",
    }),
  },
  title: {
    fontWeight: "700",
    marginBottom: tranformPx(16),
    ...(IS_WEB
      ? {
          fontSize: 22,
          color: "rgba(255, 255, 255, 0.8)",
        }
      : {
          fontSize: tranformPx(18),
          color: "#fff",
        }),
  },
  card: {
    flex: 1,
    borderRadius: 16,
    borderWidth: 1,
    ...(IS_WEB
      ? {
          padding: 32,
          borderColor: "#3F434F",
        }
      : {
          padding: 16,
          borderColor: "#303030",
        }),
  },
  img: {
    width: "100%",
    height: IS_WEB ? 94 : tranformPx(62),
    aspectRatio: 5,
    marginBottom: tranformPx(6),
  },
  text: {
    lineHeight: 30,
    color: "rgba(255, 255, 255, 0.75)",
    textAlign: IS_WEB ? "justify" : "left",
    ...(!IS_WEB && { fontSize: tranformPx(14) }),
  },
});
